<template>
  <div>
    <p class="my-5">
      If you have already completed the Workplace Safety lessons and quizzes in the Secure Student
      Area of your school careers website, you can use that certificate here.
    </p>

    <p class="my-5">
      Click on the button below to check to see if you have already completed this and have a
      certificate. The system will automatically get it and upload it here for you if one is
      available.
    </p>
    <use-ct-ws-cert />
  </div>
</template>

<script>
import UseCtWsCert from '@/views/WorkExperiences/components/Prework/Student/WorkplaceSafety/Components/UseCTWSCert';
export default {
  components: { UseCtWsCert },
};
</script>
